export default {
	meta: {
		title: 'Accueil',
		description: 'Accueil'
	}
};
